import { useNavigate as useReactNavigate } from 'react-router';

let _path = '';

export function cypressNavigatePath(): string {
  return _path;
}

function cypressNavigate(path: string): void {
  _path = path;
}

export const useNavigate = (): any => {
  if (window.hasOwnProperty('Cypress')) {
    return cypressNavigate;
  } else {
    return HookNavigate();
  }
};

const HookNavigate = (): any => {
  const navigate = useReactNavigate();
  return navigate;
};
